module.exports = __webpack_public_path__ + "img/2.32bf0100.png";